module.exports = __webpack_public_path__ + "images/dabaed5728b9ea2eb88b2678c6338722.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/julia.jpg
// module id = 129
// module chunks = 24